/* eslint-disable react/jsx-one-expression-per-line */
import { MainLayout } from 'layouts'
import { isLkmDomain } from 'router/utils'
import { LK_DOMAIN, LKM_DOMAIN } from 'constants/domains'

import style from './PersonalAgreement.module.scss'

export const PersonalAgreement = () => {
  const cabinetDomain = isLkmDomain() ? LKM_DOMAIN : LK_DOMAIN
  const privacyPolicyUrl = `https://${cabinetDomain}/privacy-policy/`

  return (
    <MainLayout>
      <div className='container'>
        <section className={style.privacyPolicy}>
          <h1>Согласие на обработку персональных данных</h1>
          <p>
            Я, заполняя форму на сайте {cabinetDomain} и проставляя отметку в
            соответствующем поле, действуя свободно, своей волей и в своём
            интересе, даю конкретное, предметное, информированное, сознательное
            и однозначное согласие ООО «ДОРХАН» (далее – Оператор) на обработку
            моих персональных данных в соответствии с Федеральным законом от
            27.07.2006 № 152-ФЗ «О персональных данных».
          </p>
          <h2>СВЕДЕНИЯ ОБ ОПЕРАТОРЕ</h2>
          <div>
            <table>
              <thead>
                <tr>
                  <th>Реквизит</th>
                  <th>Значение</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Полное наименование</td>
                  <td>Общество с ограниченной ответственностью «ДОРХАН»</td>
                </tr>
                <tr>
                  <td>Сокращённое наименование</td>
                  <td>ООО «ДОРХАН»</td>
                </tr>
                <tr>
                  <td>ИНН</td>
                  <td>7731169654</td>
                </tr>
                <tr>
                  <td>КПП</td>
                  <td>503201001</td>
                </tr>
                <tr>
                  <td>ОГРН</td>
                  <td>1027739622932</td>
                </tr>
                <tr>
                  <td>Адрес</td>
                  <td>
                    143002, Московская область, городской округ Одинцовский,
                    село Акулово, улица Новая, дом 120, строение 1, офис 531
                  </td>
                </tr>
                <tr>
                  <td>Телефон</td>
                  <td>+7 495 933-24-33</td>
                </tr>
                <tr>
                  <td>Электронная почта</td>
                  <td>info@doorhan.ru</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h2>1. Цели обработки персональных данных:</h2>
          <p>
            1.1. Обработка обращений и заявок, направленных через сайт Оператора
            (в том числе в формах «Купить/Оставить заявку», «Задать вопрос
            специалисту», «Стать дилером», «Письмо директору», «Оставить отзыв»,
            «Рассчитать стоимость», «Получить коммерческое предложение»).
          </p>
          <p>
            1.2. Предоставление ответов и консультаций по вопросам, связанным с
            продукцией Оператора.
          </p>
          <p>
            1.3. Подготовка коммерческих предложений и подбор товаров и услуг.
          </p>
          <p>1.4. Обработка заявок на дилерское сотрудничество.</p>
          <p>1.5. Установление и поддержание обратной связи.</p>
          <p>
            1.6. Обеспечение работоспособности и безопасности сайта, анализ
            посещаемости и улучшение качества сайта.
          </p>
          <p>
            1.7. Направление информационных и рекламных сообщений (при отдельном
            согласии).
          </p>
          <h2>2. Перечень обрабатываемых персональных данных:</h2>
          <p>
            2.1. Данные, указываемые мной в формах на сайте: фамилия, имя,
            отчество (при наличии), номер телефона, адрес электронной почты,
            регион, адрес для корреспонденции, адрес или место предполагаемой
            установки продукции, наименование организации, должность, содержание
            обращения, иные сведения, добровольно указанные мной.
          </p>
          <p>
            2.2. Технические данные, автоматически передаваемые при
            использовании сайта: IP-адрес, файлы cookie, сведения о браузере,
            устройстве, операционной системе, источник перехода, дата и время
            посещения, сведения о действиях на сайте.
          </p>
          <h2>3. Перечень действий с персональными данными:</h2>
          <p>
            Оператор вправе совершать следующие действия: сбор, запись,
            систематизация, накопление, хранение, уточнение (обновление,
            изменение), извлечение, использование, передача (предоставление),
            обезличивание, блокирование, удаление, уничтожение.
          </p>
          <h2>4. Передача персональных данных третьим лицам:</h2>
          <p>
            4.1. Я даю согласие на передачу моих персональных данных официальным
            дилерам DoorHan, выбранным с учётом региона и содержания моего
            обращения, в целях:
          </p>
          <ul>
            <li>
              консультирования по техническим характеристикам, особенностям и
              применению изделий;
            </li>
            <li>
              предварительного расчёта стоимости изделия и услуг по его
              установке;
            </li>
            <li>подготовки коммерческого предложения;</li>
            <li>
              последующей продажи изделия и его установки (в случае заключения
              договора с дилером).
            </li>
          </ul>
          <p>
            Дилеру могут быть переданы: фамилия, имя, отчество, номер телефона,
            адрес электронной почты, регион, адрес установки, сведения об
            организации и содержание обращения — в зависимости от данных,
            указанных мной в форме.
          </p>
          <p>
            4.2. Я даю согласие на передачу технических данных (IP-адрес, файлы
            cookie, сведения о браузере, устройстве, действиях на сайте) ООО
            «ЯНДЕКС» (119021, город Москва, улица Льва Толстого, дом 16) для
            целей веб-аналитики в рамках сервиса Яндекс.Метрика.
          </p>
          <p>
            4.3. Я даю согласие на передачу персональных данных лицам,
            обеспечивающим работу сайта, хостинга, средств связи и технической
            поддержки, исключительно в объёме, необходимом для достижения целей,
            указанных в п. 1, и при условии соблюдения ими конфиденциальности и
            безопасности персональных данных.
          </p>
          <p>
            4.4. Оператор не осуществляет трансграничную передачу моих
            персональных данных. Все данные обрабатываются и хранятся на
            серверах, расположенных на территории Российской Федерации.
          </p>
          <h2>5. Срок действия согласия:</h2>
          <p>
            Настоящее согласие действует в течение 3 (трёх) лет с момента его
            подписания (проставления отметки), но не дольше достижения целей
            обработки, если иное не установлено законодательством Российской
            Федерации.
          </p>
          <h2>6. Порядок отзыва согласия:</h2>
          <p>
            Согласие может быть отозвано мной в любое время путём направления
            письменного заявления на адрес электронной почты info@doorhan.ru или
            по почтовому адресу: 143002, Московская область, городской округ
            Одинцовский, село Акулово, улица Новая, дом 120, строение 1, офис
            531.
          </p>
          <h2>
            7. Порядок уничтожения персональных данных после отзыва согласия:
          </h2>
          <p>
            После получения моего отзыва Оператор прекращает обработку и
            уничтожает мои персональные данные в течение 30 календарных дней,
            если их дальнейшая обработка не требуется по иному законному
            основанию (в том числе для исполнения договора, требований
            налогового или бухгалтерского законодательства).
          </p>
          <h2>8. Подтверждение:</h2>
          <p>
            Проставление отметки в соответствующем поле и отправка формы на
            сайте {cabinetDomain} подтверждают предоставление мной настоящего
            согласия в форме, позволяющей подтвердить факт его получения.
          </p>
          <p>
            Подробная информация об обработке персональных данных содержится в
            Политике обработки персональных данных, размещённой по адресу:{' '}
            {privacyPolicyUrl}.
          </p>
        </section>
      </div>
    </MainLayout>
  )
}
